import { render, staticRenderFns } from "./LegalFormSelector.vue?vue&type=template&id=06317a3c&"
import script from "./LegalFormSelector.vue?vue&type=script&lang=js&"
export * from "./LegalFormSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LegalFormSelector.vue"
export default component.exports